var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#0000E3",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1979 7.83594V19.25H8.3151V10.0703L5.52604 11.0156V9.46094L9.97135 7.83594H10.1979ZM21.776 17.75V19.25H14.151V17.9609L17.8542 13.9219C18.2604 13.4635 18.5807 13.0677 18.8151 12.7344C19.0495 12.401 19.2135 12.1016 19.3073 11.8359C19.4063 11.5651 19.4557 11.3021 19.4557 11.0469C19.4557 10.6875 19.388 10.3724 19.2526 10.1016C19.1224 9.82552 18.9297 9.60938 18.6745 9.45312C18.4193 9.29167 18.1094 9.21094 17.7448 9.21094C17.3229 9.21094 16.9688 9.30208 16.6823 9.48438C16.3958 9.66667 16.1797 9.91927 16.0339 10.2422C15.888 10.5599 15.8151 10.9245 15.8151 11.3359H13.9323C13.9323 10.6745 14.0833 10.0703 14.3854 9.52344C14.6875 8.97135 15.125 8.53385 15.6979 8.21094C16.2708 7.88281 16.9609 7.71875 17.7682 7.71875C18.5286 7.71875 19.1745 7.84635 19.7057 8.10156C20.237 8.35677 20.6406 8.71875 20.9167 9.1875C21.1979 9.65625 21.3385 10.2109 21.3385 10.8516C21.3385 11.2057 21.2813 11.5573 21.1667 11.9062C21.0521 12.2552 20.888 12.6042 20.6745 12.9531C20.4661 13.2969 20.2188 13.6432 19.9323 13.9922C19.6458 14.3359 19.3307 14.6849 18.987 15.0391L16.526 17.75H21.776Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.7c71143833a5d33c7f208bc3aab74e4c.svg";
export { ForwardRef as ReactComponent };